<template>
  <figure class="m-0">
    <!-- Generator: Adobe Illustrator 24.0.2, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
    <svg ref="svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 410 216" style="enable-background:new 0 0 410 216;" xml:space="preserve">
    <rect y="0.7" class="field-bg" width="410" height="214.6"/>
    <rect x="391" y="92.5" class="field-bg" width="14" height="34"/>
    <rect x="0" y="92.5" class="field-bg" width="14" height="34"/>
    <path class="field-bg" d="M402.2,185.5c-5.1,0-10.2-0.5-15.2-1.5c-9.6-2-18.8-5.9-26.9-11.4c-16.4-11.2-27.7-28.3-31.6-47.7
        c-2-10.1-2-20.5,0-30.6c3.9-19.4,15.3-36.5,31.6-47.7c12.4-8.5,27.1-13,42.1-13c0.9,0,1.8,0,2.8,0v151.9
        C404.1,185.5,403.2,185.5,402.2,185.5z"/>
    <path class="field-lines" d="M0,0.7v30.4v59.7v34.4v59.7v30.4h118.3h3h82.4h3h82.4h3H410v-30.4v-59.7V90.8V31.1V0.7H0z M3,93.8h8.1v28.3H3
        V93.8z M3,125.2h11.1V90.8H3V34.1c4.9,0,9.8,0.5,14.5,1.5c4.7,1,9.3,2.4,13.7,4.3c4.3,1.9,8.5,4.1,12.4,6.8c3.9,2.6,7.5,5.7,10.8,9
        c3.3,3.3,6.3,7,8.9,10.9c2.6,4,4.9,8.2,6.7,12.6c1.9,4.5,3.3,9.1,4.3,13.9c1,4.9,1.5,9.9,1.5,14.9c0,5-0.5,10-1.5,14.9
        c-1,4.7-2.4,9.4-4.3,13.9c-1.8,4.4-4.1,8.6-6.7,12.6c-2.6,3.9-5.6,7.6-8.9,10.9c-3.3,3.3-7,6.4-10.8,9c-3.9,2.7-8.1,5-12.4,6.8
        c-4.4,1.9-9,3.3-13.7,4.3c-4.7,1-9.6,1.5-14.5,1.5V125.2z M3,212.3v-27.3c5.1,0,10.2-0.5,15.1-1.6c4.9-1,9.7-2.5,14.3-4.5
        c4.5-1.9,8.9-4.3,12.9-7.1c4-2.8,7.8-5.9,11.3-9.4c3.4-3.5,6.6-7.3,9.3-11.4c2.8-4.1,5.1-8.5,7-13.1c1.9-4.6,3.4-9.5,4.4-14.4
        c1-5.1,1.5-10.3,1.5-15.5s-0.5-10.4-1.5-15.5c-1-4.9-2.5-9.8-4.4-14.4c-1.9-4.6-4.3-9-7-13.1c-2.7-4.1-5.9-7.9-9.3-11.4
        c-3.4-3.5-7.2-6.6-11.3-9.4c-4.1-2.8-8.4-5.2-12.9-7.1c-4.6-2-9.4-3.5-14.3-4.5c-4.9-1-10-1.5-15.1-1.6V3.7h115.3v208.5H3z
        M121.4,212.3V3.7h82.4v208.5H121.4z M206.8,212.3V3.7h82.4v208.5H206.8z M407,122.2h-8.1V93.8h8.1V122.2z M407,90.8h-11.1v34.4H407
        v56.7c-4.9,0-9.8-0.5-14.5-1.5c-4.7-1-9.3-2.4-13.7-4.3c-4.3-1.9-8.5-4.1-12.4-6.8c-3.9-2.6-7.5-5.7-10.8-9c-3.3-3.3-6.3-7-8.9-10.9
        c-2.6-4-4.9-8.2-6.7-12.6c-1.9-4.5-3.3-9.1-4.3-13.9c-1-4.9-1.5-9.9-1.5-14.9c0-5,0.5-10,1.5-14.9c1-4.7,2.4-9.4,4.3-13.9
        c1.8-4.4,4.1-8.6,6.7-12.6c2.6-3.9,5.6-7.6,8.9-10.9c3.3-3.3,7-6.4,10.8-9c3.9-2.7,8.1-5,12.4-6.8c4.4-1.9,9-3.3,13.7-4.3
        c4.7-1,9.6-1.5,14.5-1.5V90.8z M407,31.1c-5.1,0-10.2,0.5-15.1,1.6c-4.9,1-9.7,2.5-14.3,4.5c-4.5,1.9-8.9,4.3-12.9,7.1
        c-4,2.8-7.8,5.9-11.3,9.4c-3.4,3.5-6.6,7.3-9.3,11.4c-2.8,4.1-5.1,8.5-7,13.1c-1.9,4.6-3.4,9.5-4.4,14.4c-1,5.1-1.5,10.3-1.5,15.5
        s0.5,10.4,1.5,15.5c1,4.9,2.5,9.8,4.4,14.4c1.9,4.6,4.3,9,7,13.1c2.7,4.1,5.9,7.9,9.3,11.4c3.4,3.5,7.2,6.6,11.3,9.4
        c4.1,2.8,8.4,5.2,12.9,7.1c4.6,2,9.4,3.5,14.3,4.5c4.9,1,10,1.5,15.1,1.6v27.3H292.2V3.7H407V31.1z"/>
    <g class="player-position goalie">
        <g class="position">
            <circle id="Ellipse_599_1_" class="position" cx="13" cy="108" r="7.5"/>
            <path class="position" d="M30.4,106c-0.1-0.5-0.4-0.9-0.8-1.1s-0.8-0.4-1.4-0.4c-0.8,0-1.4,0.3-1.9,0.9s-0.7,1.4-0.7,2.5
                s0.2,1.9,0.7,2.5s1.1,0.9,1.9,0.9c0.7,0,1.3-0.2,1.7-0.6s0.6-0.9,0.6-1.5h-2.2v-1.6h4.3v1.3c0,0.9-0.2,1.7-0.6,2.3
                c-0.4,0.6-0.9,1.1-1.6,1.5s-1.4,0.5-2.3,0.5c-1,0-1.8-0.2-2.5-0.6s-1.3-1-1.7-1.8s-0.6-1.7-0.6-2.8c0-1.1,0.2-2,0.6-2.8
                c0.4-0.8,1-1.4,1.7-1.8s1.5-0.6,2.4-0.6c0.8,0,1.5,0.1,2.1,0.4s1.1,0.7,1.5,1.2s0.6,1.1,0.7,1.8h-1.9V106z"/>
        </g>
    </g>
    <g class="player-position defense">
        <g class="position">
            <circle id="Ellipse_601-3_1_" class="position" cx="120" cy="35.7" r="7.5"/>
            <path class="position" d="M134.1,40.8h-3.6V30.6h3.6c1,0,1.9,0.2,2.6,0.6c0.7,0.4,1.3,1,1.7,1.7c0.4,0.8,0.6,1.7,0.6,2.7
                c0,1.1-0.2,2-0.6,2.7c-0.4,0.8-1,1.3-1.7,1.8C136,40.6,135.1,40.8,134.1,40.8z M132.7,39h1.4c1,0,1.7-0.3,2.2-0.8s0.7-1.3,0.7-2.5
                c0-1.1-0.2-2-0.7-2.5s-1.2-0.8-2.2-0.8h-1.4C132.7,32.4,132.7,39,132.7,39z"/>
        </g>
        <g class="position">
            <circle id="Ellipse_600_1_" class="position" cx="120" cy="108" r="7.5"/>
            <path class="position" d="M134.1,113.1h-3.6v-10.2h3.6c1,0,1.9,0.2,2.6,0.6c0.7,0.4,1.3,1,1.7,1.7c0.4,0.8,0.6,1.7,0.6,2.7
                c0,1.1-0.2,2-0.6,2.7c-0.4,0.8-1,1.3-1.7,1.8C136,112.9,135.1,113.1,134.1,113.1z M132.7,111.3h1.4c1,0,1.7-0.3,2.2-0.8
                s0.7-1.3,0.7-2.5c0-1.1-0.2-2-0.7-2.5s-1.2-0.8-2.2-0.8h-1.4C132.7,104.7,132.7,111.3,132.7,111.3z"/>
        </g>
        <g class="position">
            <circle id="Ellipse_601_3_" class="position" cx="120" cy="180.3" r="7.5"/>
            <path class="position" d="M134.1,185.4h-3.6v-10.2h3.6c1,0,1.9,0.2,2.6,0.6c0.7,0.4,1.3,1,1.7,1.7c0.4,0.8,0.6,1.7,0.6,2.7
                c0,1.1-0.2,2-0.6,2.7c-0.4,0.8-1,1.3-1.7,1.8C136,185.2,135.1,185.4,134.1,185.4z M132.7,183.6h1.4c1,0,1.7-0.3,2.2-0.8
                s0.7-1.3,0.7-2.5c0-1.1-0.2-2-0.7-2.5s-1.2-0.8-2.2-0.8h-1.4C132.7,177,132.7,183.6,132.7,183.6z"/>
        </g>
    </g>
    <g class="player-position midfield">
        <g class="position">
            <circle id="Ellipse_601-3_2_" class="position" cx="204.5" cy="35.7" r="7.5"/>
            <path class="position" d="M214.5,30.6h2.7l2.8,6.8h0.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-0.1l-2.6,6.6h-1.4l-2.6-6.6h-0.1v6.7h-2.1
                L214.5,30.6L214.5,30.6z"/>
        </g>
        <g class="position">
            <circle id="Ellipse_600_2_" class="position" cx="204.5" cy="108" r="7.5"/>
            <path class="position" d="M214.5,102.9h2.7l2.8,6.8h0.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-0.1l-2.6,6.6h-1.4l-2.6-6.6h-0.1v6.7h-2.1
                L214.5,102.9L214.5,102.9z"/>
        </g>
        <g class="position">
            <circle id="Ellipse_601_1_" class="position" cx="204.5" cy="180.3" r="7.5"/>
            <path class="position" d="M214.5,175.1h2.7l2.8,6.8h0.1l2.8-6.8h2.7v10.2h-2.1v-6.6h-0.1l-2.6,6.6h-1.4l-2.6-6.6h-0.1v6.7h-2.1
                L214.5,175.1L214.5,175.1z"/>
        </g>
    </g>
    <g class="player-position forward">
        <g class="position">
            <circle id="Ellipse_600_3_" class="position" cx="290.6" cy="108" r="7.5"/>
            <path class="position" d="M301,113.1v-10.2h6.7v1.8h-4.6v2.4h4.1v1.8h-4.1v4.2H301z"/>
        </g>
        <g class="position">
            <circle id="Ellipse_601_2_" class="position" cx="290.6" cy="180.3" r="7.5"/>
            <path class="position" d="M301,185.4v-10.2h6.7v1.8h-4.6v2.4h4.1v1.8h-4.1v4.2H301z"/>
        </g>
        <g class="position">
            <path class="position" d="M301,40.8V30.6h6.7v1.8h-4.6v2.4h4.1v1.8h-4.1v4.2H301z"/>
            <circle id="Ellipse_601-3_3_" class="position" cx="290.6" cy="35.7" r="7.5"/>
        </g>
    </g>
    </svg>

  </figure>
</template>

<script>
import positionsLogic from './AthletePositionsLogic';
export default {
    mixins: [ positionsLogic ]
}
</script>

<style>

</style>